export const DOWNLOAD_DOCUMENTS_URL = '/idai-service/download_documents';
export const GET_VEHICLE_DOCUMENTS_URL = '/idai-service/get_expediente';
export const DELETE_VEHICLE_DOCUMENT_URL = '/idai-service/delete_document';
export const GET_VEHICLE_DOCUMENTS_KEY = 'get-vehicle-documents';
export const GET_UPLOAD_DOCUMENTS_KEY = '/idai-service/upload_document_wallet';
